module.exports = __webpack_public_path__ + "img/2.5b1e5b20.jpg";